import { render, staticRenderFns } from "./SurfaceZonificationItem.vue?vue&type=template&id=255084ca&scoped=true"
import script from "./SurfaceZonificationItem.vue?vue&type=script&lang=ts"
export * from "./SurfaceZonificationItem.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceZonificationItem.vue?vue&type=style&index=0&id=255084ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255084ca",
  null
  
)

export default component.exports